import $ from 'jquery'
import { DirectiveOptions } from 'vue/types/options'

import 'slick-carousel'

const slickCarousel: DirectiveOptions = {
  inserted(el: HTMLElement, node) {
    const target = $(el)
    const setting = node.value ? node.value : {}
    target.slick(setting)
  },
}

export default slickCarousel
